/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import styled from '@emotion/styled';
import LinearProgress from '@material-ui/core/LinearProgress';
import PropTypes from 'prop-types';
import { Spacings } from '../../../styleConstants';

const StyledProgress = styled(LinearProgress)`
  &.MuiLinearProgress-root {
    background-color: ${({ $backgroundColor }) => $backgroundColor};
    width: ${({ $width }) => $width};
    height: ${({ $height }) => $height};
    align-self: center;
    border-radius: ${({ $borderRadius }) => $borderRadius};
  }
  &.MuiLinearProgress-root .MuiLinearProgress-bar {
    border-radius: ${({ borderRadius }) => borderRadius};
    background-color: ${({ $overlayColor }) => $overlayColor};
  }
`;

const LinearProgressBar = ({
  value,
  variant,
  width,
  height,
  borderRadius,
  backgroundColor,
  overlayColor,
  className,
  onMouseOver,
  onMouseOut
}) => {
  const progress = value > 100 ? 100 : value;
  return (
    <StyledProgress
      variant={variant}
      value={progress}
      $width={width}
      $height={height}
      $borderRadius={borderRadius}
      $backgroundColor={backgroundColor}
      $overlayColor={overlayColor}
      className={className}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    />
  );
};

export default LinearProgressBar;

LinearProgressBar.propTypes = {
  variant: PropTypes.string,
  value: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  backgroundColor: PropTypes.string,
  overlayColor: PropTypes.string,
  className: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func
};

LinearProgressBar.defaultProps = {
  variant: 'determinate',
  width: '105px',
  height: Spacings.SPACING_1B,
  borderRadius: Spacings.SPACING_5B,
  backgroundColor: 'var(--color-divider)',
  overlayColor: 'var(--color-i-green)',
  className: '',
  onMouseOver: null,
  value: 0,
  onMouseOut: () => {}
};
